<template>
    <div class="row p-5">
        <div class="col-8 mx-auto">
            <!-- STEP ONE -->
            <div class="box p-3">
                <div class="mb-3 text-center">
                    <h2>{{ $t("products.stepOne") }} - {{ $t("products.typeOfCalculation") }}</h2>
                </div>
                <div class="d-flex justify-content-center gap-5">
                    <div>
                        <input type="radio" class="form-check-input me-1" value="knowInputOutput"
                            v-model="calculation.typeOfCalculation">
                        <label class="form-check-label">{{ $t("products.knowInputOutput") }}</label>
                    </div>
                    <div>
                        <input type="radio" class="form-check-input me-1" value="knowOutputKoeficient"
                            v-model="calculation.typeOfCalculation">
                        <label class="form-check-label">{{ $t("products.knowOutputKoeficient") }}</label>
                    </div>
                    <div>
                        <input type="radio" class="form-check-input me-1" value="knowInputKoeficient"
                            v-model="calculation.typeOfCalculation">
                        <label class="form-check-label">{{ $t("products.knowInputKoeficient") }}</label>
                    </div>
                </div>
            </div>
            <!-- STEP TWO -->
            <div class="box mt-3 p-3 step_two"
                v-if="calculation.typeOfCalculation === 'knowInputOutput' || calculation.typeOfCalculation === 'knowInputKoeficient'">
                <div class="mb-3 text-center">
                    <h2>{{ $t("products.stepTwo") }} - {{ $t("products.inputProducts") }}</h2>
                </div>
                <div class="d-flex justify-content-center gap-5">
                    <select class="form-select w-25" v-model="calculation.inputs[0]">
                        <option :value="null">
                            {{ $t("products.selectProduct") }}
                        </option>
                        <option v-for="product in products" :key="product.id" :value="product">
                            {{ product.name }}
                        </option>
                    </select>
                    <select class="form-select w-25" v-model="calculation.inputs[1]">
                        <option :value="null">
                            {{ $t("products.selectProduct") }}
                        </option>
                        <option v-for="product in products" :key="product.id" :value="product">
                            {{ product.name }}
                        </option>
                    </select>
                    <select class="form-select w-25" v-model="calculation.inputs[2]">
                        <option :value="null">
                            {{ $t("products.selectProduct") }}
                        </option>
                        <option v-for="product in products" :key="product.id" :value="product">
                            {{ product.name }}
                        </option>
                    </select>
                </div>
            </div>
            <!-- STEP THREE -->
            <div class="box mt-3 p-3 step_three"
                v-if="calculation.typeOfCalculation === 'knowOutputKoeficient' || calculation.typeOfCalculation === 'knowInputOutput'">
                <div class="mb-3 text-center">
                    <h2>{{ $t("products.stepThree") }} - {{ $t("products.outputProducts") }}</h2>
                </div>
                <div class="d-flex justify-content-center gap-5">
                    <select class="form-select w-25" v-model="calculation.outputs[0]">
                        <option :value="null">
                            {{ $t("products.selectProduct") }}
                        </option>
                        <option v-for="product in products" :key="product.id" :value="product">
                            {{ product.name }}
                        </option>
                    </select>
                    <select class="form-select w-25" v-model="calculation.outputs[1]">
                        <option :value="null">
                            {{ $t("products.selectProduct") }}
                        </option>
                        <option v-for="product in products" :key="product.id" :value="product">
                            {{ product.name }}
                        </option>
                    </select>
                    <select class="form-select w-25" v-model="calculation.outputs[2]">
                        <option :value="null">
                            {{ $t("products.selectProduct") }}
                        </option>
                        <option v-for="product in products" :key="product.id" :value="product">
                            {{ product.name }}
                        </option>
                    </select>
                </div>
            </div>
            <!-- STEP FOUR -->
            <div class="box mt-3 p-3 step_four" v-if="(calculation.inputs && calculation.inputs.some(input => input !== null)) ||
                (calculation.outputs && calculation.outputs.some(output => output !== null))">
                <div class="mb-2 text-center">
                    <h2>{{ $t("products.stepFour") }} - {{ $t("products.calculations") }}</h2>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6 col-xl-4">
                        <span style="font-size: 24px;">{{ $t("products.input") }}</span>
                        <div v-for="(input, index) in calculation.inputs" :key="index" class="mt-2">
                            <div v-if="input && input.name" class="d-flex align-items-center">
                                <span class="me-2">{{ input.name }}</span>
                                <input type="number" class="form-control me-2" style="width: 100px;">
                                <span>{{ input.measurement_unit }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-xl-4">
                        <span style="font-size: 24px;">{{ $t("products.output") }}</span>
                        <div v-for="(output, index) in calculation.outputs" :key="index" class="mt-2">
                            <div v-if="output && output.name" class="d-flex align-items-center">
                                <span class="me-2">{{ output.name }}</span>
                                <input type="number" class="form-control me-2" style="width: 100px;">
                                <span>{{ output.measurement_unit }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-xl-4">
                        <span style="font-size: 24px;">{{ $t("products.koeficient") }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import { IconArrowBigRightLines } from '@tabler/icons-vue'

export default {
    components: {
        IconArrowBigRightLines
    },
    data() {
        return {
            products: [],
            createdProducts: [],
            error: null,
            calculation: {
                typeOfCalculation: null,
                inputs: [null, null, null],
                outputs: [null, null, null],
            },
            selectedOption: null
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.$store.getters.api.get("/unhidden_products").then((response) => {
                this.products = response.data.items
            })
        },
        pickOption(option) {
            this.selectedOption = option;
            console.log(this.selectedOption);
        },
        submitTransfer() {
            this.$store.getters.api.put("/warehouse/" + this.$route.params.id + "/product_conversion/submit", this.selectedOption
            ).then((response) => {
                this.$router.push({ name: "WarehouseStock", params: { id: this.$route.params.id } })
            });
        }
    },
    watch: {
        postData: {
            handler(newVal, oldVal) {
                if (newVal.product) {
                    this.error = null;
                    this.selectedOption = null;

                    setTimeout(() => {
                        this.$store.getters.api.get("/warehouse/" + this.$route.params.id + "/product_conversions", {
                            params: this.postData
                        }).then((response) => {
                            this.createdProducts = response.data.items;
                            if (response.data.error) {
                                this.error = this.$t("products.noOption");
                            }
                        });
                    }, 100); // 100ms delay
                }
            },
            deep: true
        }
    }
}
</script>
<style scoped lang="scss">
@import "@/scss/abstracts/variables";

.box {
    border: 1px solid black;
    border-radius: 5px;
    height: 150px;
}

.step_four {
    height: 250px;
}

.icon_container {
    height: 250px;
}

.option {
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    padding: 10px 8px;

    &:hover {
        background-color: $primary;
        cursor: pointer;
    }

    &.selected {
        background-color: $primary;
        cursor: pointer;
    }

    &.dimmed {
        opacity: 0.5;
    }
}

.icon {
    width: 80px;
    height: 80px;
}
</style>